import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import { Card, CardBody, Modal } from "reactstrap";
import * as yup from "yup";
import * as XLSX from "xlsx";
import { getUserList } from "../../../redux/invoice/action";
import { exportAllReports, getAllReports } from "../../../redux/service/action";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { formatDate } from "../../Common/Utils/dateUtils";
import TestingAccountFilter from "../../Common/TestingAccountFilter";

export const invoiceReportValidation = () =>
  yup.object({
    start_date: yup.date(),
    end_date: yup
      .date()
      .min(yup.ref("start_date"), "End date cannot be before start date"),
    // invoice_type: yup.number(),
    // user_id: yup.string().required("This Field is required"),
  });

const CustomerReport = () => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsMember, setSelectedOptionsMember] = useState([]);
  const [reportsData, setReportsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);
  const [showFilter, setSHowFilter] = useState(false);

  const userList = useSelector((state) => state?.reusableSlice?.userList);

  const [startDates, setStartDates] = useState("");
  const [endDates, setEndDates] = useState("");
  const [params, setParams] = useState({
    page: 1,
    search_key: "",
    status: "",
  });

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const invoiceOptions = [
    {
      value: 0,
      label: "Simplified",
    },
    {
      value: 1,
      label: "VAT",
    },
    {
      value: 2,
      label: "Purchase",
    },
  ];
  const proOptions = userList?.users?.map((item) => ({
    value: item?.id,
    label: item?.full_name,
  }));

  useEffect(() => {
    dispatch(getUserList(params));
  }, [dispatch, params]);

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    formik.setFieldValue("user_id", selected?.value);
  };

  const handleChangeMember = (selected) => {
    setSelectedOptionsMember(selected);
    formik.setFieldValue("invoice_type", selected?.value);
  };

  const handleStartDateChange = (event) => {
    setStartDates(event.target.value);
    formik.setFieldValue("start_date", event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDates(event.target.value);
    formik.setFieldValue("end_date", event.target.value);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      start_date: "",
      end_date: "",
      testing_account_filter: "hide",
      type: "customer_report",
    },
    validationSchema: invoiceReportValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleGetReports = (data) => {
    getAllReports(data)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          setReportsData(res.data.response.customer_report);
        }
      })
      .catch((e) => {
        console.log(e, "error in get report");
        setIsLoading(false);
      });
  };

  const handleExportReport = () => {
    const myData = {
      ...formik.values,
    };
    setExportLoader(true);
    exportAllReports(myData)
      .then((response) => {
        if (response.data) {
          setExportLoader(false);
          const header = [
            "Sl",
            "Company Name",
            "Full Name",
            "Mobile Number",
            "Email Address",
            "Invoice Type",
            "Created On",
          ];
          const worksheet = XLSX.utils.json_to_sheet([
            header,
            ...response.data.customer_report.map((prop, index) => [
              index + 1,
              prop.company_name,
                prop.full_name,
                `${prop.country_code} - ${prop.mobile_number}`,
                prop.email_id,
                prop.invoice_type === 0
                ? "Simplified"
                : prop.invoice_type === 1
                ? "VAT"
                : "Purchase",
                formatDate(prop.created_on, ""),
            ]),
          ]);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          XLSX.writeFile(workbook, "CustomerReport.xlsx");
        }
      })
      .catch((e) => {
        console.log(e, "while exporting reports");
        setExportLoader(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    const data = {
      type: "customer_report",
      testing_account_filter: "hide",
    };
    handleGetReports(data);
  }, []);

  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    handleGetReports(data);
  };

  return (
    <Card className="p-3">
      <div className="category-wrapper">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Customer Report</h4>
          <div className="d-flex justify-content-between align-items-center ">
            <button
              type="button"
              className="submit-btn  filter-btn mx-5"
              onClick={() => setSHowFilter(!showFilter)}
            >
              <span>
                <i className="fa-solid fa-filter"></i>{" "}
                {showFilter ? "Hide Filter" : "Filter"}
              </span>
            </button>
            <button
              disabled={exportLoader}
              type="button"
              className="submit-btn"
              onClick={() => handleExportReport()}
              style={{ width: "max-content" }}
            >
              {exportLoader ? <Spinner /> : "Export"}
            </button>
          </div>
        </div>
        {showFilter && <form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-md-3 form-group">
              <label>Start Date</label>
              <input
                type="date"
                className="form-control w-100"
                placeholder="Enter start date"
                value={startDates}
                onChange={handleStartDateChange}
                onBlur={formik.handleBlur}
                name="start_date"
              />
              {formik.touched.start_date && formik.errors.start_date ? (
                <div className="error">{formik.errors.start_date}</div>
              ) : null}
            </div>

            <div className="col-md-3 form-group">
              <label>End Date</label>
              <input
                type="date"
                className="form-control w-100"
                placeholder="Enter end date"
                value={endDates}
                onChange={handleEndDateChange}
                onBlur={formik.handleBlur}
                min={startDates || undefined}
                name="end_date"
              />
              {formik.touched.end_date && formik.errors.end_date ? (
                <div className="error">{formik.errors.end_date}</div>
              ) : null}
            </div>
            <TestingAccountFilter
              value={formik.values.testing_account_filter}
              onChange={formik.handleChange}
            />
            <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Submit" : <Spinner />}
            </button>
            <button
              type="button"
              className="submit-btn  "
              onClick={() => {
                setSelectedOptions("");
                formik.resetForm();
                handleGetReports({
                  type: "customer_report",
                  testing_account_filter: "hide",
                });
              }}
              style={{ width: "max-content" }}
            >
              Clear
            </button>
          </div>
          </div>

       
        </form>}
      </div>
      {isLoading ? (
        <FullScreenLoader />
      ) : (
        <div className="table-sec px-0">
          <table className="table">
            <thead>
              <tr>
                <th>Sl.No</th>
                <th>Company Name</th>
                <th>Full Name</th>
                <th>Contact Info</th>
                <th>Invoice Type</th>
                <th>Created On</th>
                {/* <th>Total</th> */}
                {/* <th className="text-center">Action</th> */}
              </tr>
            </thead>
            <tbody>
              {reportsData.length > 0 ? (
                reportsData.map((item, index) => (
                  <tr key={item.id}>
                    <td> {index + 1 + (params?.page - 1) * 10}</td>
                    <td>{item.company_name}</td>
                    <td>{item?.full_name}</td>
                    <td>
                      <p>{` ${item?.country_code}  ${item?.mobile_number}`}</p>
                      <p>{item?.email_id}</p>
                    </td>
                    <td>
                      {item.invoice_type === 0
                        ? "Simplified"
                        : item.invoice_type === 1
                          ? "VAT"
                          : "Purchase"}
                    </td>
                    <td>{formatDate(item.created_on)}</td>
                    {/* <td>{item.total}</td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Admins found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      {/* <CommonPagination
          params={params}
          setParams={setParams}
          pagination_meta={adminlist?.pagination_meta}
        /> */}
    </Card>
  );
};

export default CustomerReport;
